import { render, staticRenderFns } from "./SentenceAnalysis.vue?vue&type=template&id=003f9d80&scoped=true&"
import script from "./SentenceAnalysis.vue?vue&type=script&lang=js&"
export * from "./SentenceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./SentenceAnalysis.vue?vue&type=style&index=0&id=003f9d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003f9d80",
  null
  
)

export default component.exports